<template>
  <div class="row pl-3 pr-1">
    <div class="col-md-1 d-flex justify-content-center pr-0">
      <div
        class="avatar avatar avatar-disabled"
        style="width: 16px !important; height: 16px !important;">
        <div style="width: 16px !important; height: 16px !important;" class="avatar avatar ml-1">
          <span
            v-if="active"
            class="avatar-title mr-2 rounded-circle"
            style="font-size: .4em; background-color: #35A666">
            <i class="fe fe-check"></i>
          </span>
          <img
            v-else-if="member.picture_url"
            :src="member.picture_url"
            style="transition: 1s filter ease-out;"
            alt="..."
            class="avatar-img rounded-circle shadow-sm">
          <span
            v-else
            class="avatar-title rounded-circle"
            style="font-size: .4em">
            {{(member.first_name || '').slice(0, 1)+(member.last_name || '').slice(0, 1)}}
          </span>
        </div>
      </div>
    </div>
    <div class="col-md-6 pt-2">
      <span class="text-dark"><b>{{member.first_name}} {{ lastName }}</b></span>
    </div>
    <div class="col-md-5 pt-2">
      <span class="text-muted small float-right">{{ jobTitle }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PopoverMemberItem',
    computed: {
      lastName: function () {
        return this.member.last_name.length + this.member.first_name.length + 1 > 16 ? this.member.last_name.substr(0, 13 - this.member.first_name.length) + '...' : this.member.last_name;
      },
      jobTitle: function () {
        return this.member.job_title.length > 18 ? this.member.job_title.substr(0, 17) + '...' : this.member.job_title;
      },
    },
    props: {
      member: {
        default: function () {
          return {};
        },
      },
      active: {
        default: false,
      },
    },
  };
</script>

<style scoped>

</style>
